
import React, { useMemo, useState } from 'react';
import Papa from 'papaparse'; 
import {obtenerListas} from '../../services/api';
import { Carrera, Materia, Universidad } from '../../objetos/objeto_materias';
import { useLoading } from '../../utils/LoadingProvider';

export const useListasModel = () => {
    const { showLoading, hideLoading, withLoading } = useLoading();

    //universidades
    const [universidades, setUniversidades] = useState([]);
    const [isLoadingUniversidad, setLoadingUniversidad] = useState(false);
    const [erroruniversidades, setErrorUniversidades] = useState(null);
    //carreras
    const [carreras, setCarreras] = useState([]);
    const [isLoadingCarreras, setLoadingCarreras] = useState(false);
    const [errorCarreras, setErrorCarreras] = useState(null);
    //paises
    const [paises, setpaises] = useState([]);
    const [isLoadingpaises, setLoadingpaises] = useState(false);
    const [errorpaises, setErrorpaises] = useState(null);
    //ciudades
    const [ciudades, setciudades] = useState([]);
    const [isLoadingciudades, setLoadingciudades] = useState(false);
    const [errorciudades, setErrorciudades] = useState(null);
    //materias
    const [materias, setMaterias] = useState([]);
    const [isLoadingMaterias, setLoadingMaterias] = useState(false);
    const [errorMaterias, seterrorMaterias] = useState(null);
    //materias de plataforma
    const [materiasPlataforma, setMateriaPlataformas] = useState([]);
    const [isLoadingMateriasPlataforma, setLoadingmateriasPlataforma] = useState(false);
    const [errorMateriaPlataformas, seterrorMateriasPlataforma] = useState(null);
    //fases de plataforma
    const [fasePlataforma, setfasePlataforma] = useState([]);
    const [isLoadingfasePlataforma, setLoadingfasePlataforma] = useState(false);
    const [errorfasePlataforma, seterrorfasePlataforma] = useState(null);
    //plataforma de plataforma
    const [plataformaPlataforma, setplataformaPlataforma] = useState([]);
    const [isLoadingplataformaPlataforma, setLoadingplataformaPlataforma] = useState(false);
    const [errorplataformaPlataforma, seterrorplataformaPlataforma] = useState(null);
    //semestres de plataforma
    const [semestrePlataforma, setsemestrePlataforma] = useState([]);
    const [isLoadingsemestrePlataforma, setLoadingsemestrePlataforma] = useState(false);
    const [errorsemestrePlataforma, seterrorsemestrePlataforma] = useState(null);
    //DATOS DE CSV
    const csvUrl = "https://docs.google.com/spreadsheets/d/e/2PACX-1vRAjeXIiUwMGvCT--a0HIUWRitKpmUg0mnzFxyqI_MtLDCx9o1riLL1i8ArbKbgkVk64rc1sh1jxs4_/pub?gid=1014937931&single=true&output=csv";
    
    //lista de examenes de tutores
    const [examenesPruebasTutores, setexamenesPruebasTutores] = useState();
    const [loadingexamenesPruebasTutores, setLoadingexamenesPruebasTutores] = useState();
    const [errorexamenesPruebasTutores, setErrorexamenesPruebasTutores] = useState();

    const cargarUniversidades = async() =>{
        try{
            setLoadingUniversidad(true);

            const data = await obtenerListas.getUniversidades();
            const dataConvertida = Object.values(data);
            const universidad_obj = data.map(universidadData => Universidad.fromJson(universidadData));
            
            console.log("universidades cargadas,",data);

            setUniversidades(universidad_obj);
            setErrorUniversidades(null);

            return dataConvertida;
        }
        catch(error){
            console.error("Error al obtener datos:", error);
            setErrorUniversidades("Error al cargar los datos");
        }finally{
           setLoadingUniversidad(false);
        }
    }
    const universidadesOptions = useMemo(() => {
        return universidades?.map(universidad => ({
          value: universidad.nombreUniversidad, // o materia.id si tienes un ID
          label: universidad.nombreUniversidad,
        })) || [];
    }, [universidades]);

    const cargarCarreras = async() =>{
      try{
        setLoadingCarreras(true);
        
        const data = await obtenerListas.getCarreras();
        const dataConvertida = Object.values(data);
        console.log("data de carreras ",dataConvertida);
        const carreras_obj = data.map(universidadData => Carrera.fromJson(universidadData));
        console.log("carreras obj",carreras_obj);
        setCarreras(carreras_obj);
        setErrorCarreras(null);

        return dataConvertida;
      }
      catch(error){
        console.error("Error al obtener datos:", error);
          setErrorCarreras("Error al cargar los datos");
          
      }
      finally{
        setLoadingCarreras(false);
      }
    }
    const carrerasOptions = useMemo(() =>{
      return carreras?.map(carrera => ({
          value: carrera.nombrecarrera,
          label: carrera.nombrecarrera,
        })) || [];
    }, [carreras]);

    const cargarPaises = async() =>{
      try{
        setLoadingpaises(true);
  
        // Intentar recuperar datos de localStorage primero
        const cachedData = localStorage.getItem('paisesData');
        const lastFetch = localStorage.getItem('paisesLastFetch');
        
        // Verificar si tenemos datos en caché y si no son demasiado antiguos (24 horas)
        if (cachedData && lastFetch && (Date.now() - Number(lastFetch)) < 86400000) {
        setpaises(JSON.parse(cachedData));
        setLoadingpaises(false);
        return;
        }
  
        // Si no hay caché o es antiguo, cargar desde Google Sheets
        const response = await fetch(csvUrl);
        const csvText = await response.text();
  
        //parsear en csv
        Papa.parse(csvText, {
                  header: true, // La primera fila contiene encabezados
                  skipEmptyLines: true,
                  complete: (results) => {
                    // Filtrar filas vacías y procesar datos para Select
                    const paisesData = results.data
                      .filter(item => item.PAISES && item.PAISES !== "NO REGISTRADO")
                      .map(item => ({
                        value: item.PAISES,
                        label: item.PAISES
                      }));
                    
                    // Ordenar alfabéticamente
                    paisesData.sort((a, b) => a.label.localeCompare(b.label));
                    
                    // Actualizar estado y guardar en localStorage
                    setpaises(paisesData);
                    localStorage.setItem('paisesData', JSON.stringify(paisesData));
                    localStorage.setItem('paisesLastFetch', Date.now().toString());
                    
                    setLoadingpaises(false);
                  },
                  error: (err) => {
                    console.error("Error al parsear CSV:", err);
                    setErrorpaises("Error al procesar los datos");
                    setLoadingpaises(false);
                  }
            });
  
    }
    catch(error){
        console.error("Error al obtener datos:", error);
        setErrorpaises("Error al cargar los datos");
        setLoadingpaises(false);
    }
    finally{
        setLoadingpaises(false);
    }
    }

    const cargarCiudades = async(pais) =>{
      try{
        setLoadingciudades(true);
    
        // Intentar recuperar datos de localStorage primero
        const cachedData = localStorage.getItem('ciudadesData');
        const lastFetch = localStorage.getItem('ciudadesLastFetch');
        
        // Verificar si tenemos datos en caché y si no son demasiado antiguos (24 horas)
        if (cachedData && lastFetch && (Date.now() - Number(lastFetch)) < 86400000) {
        setciudades(JSON.parse(cachedData));
        setLoadingciudades(false);
        return;
        }
    
        // Si no hay caché o es antiguo, cargar desde Google Sheets
        const response = await fetch(csvUrl);
        const csvText = await response.text();
    
        //parsear en csv
        Papa.parse(csvText, {
                  header: true, // La primera fila contiene encabezados
                  skipEmptyLines: true,
                  complete: (results) => {
                    // Filtrar filas vacías y procesar datos para Select
                    const ciudadData = results.data
                      .filter(item => item.CIUDAD && item.CIUDAD !== "NO REGISTRADO")
                      .map(item => ({
                        value: item.CIUDAD,
                        label: item.CIUDAD
                      }));
                    
                    // Ordenar alfabéticamente
                    ciudadData.sort((a, b) => a.label.localeCompare(b.label));
                    
                    // Actualizar estado y guardar en localStorage
                    setciudades(ciudadData);
                    localStorage.setItem('ciudadesData', JSON.stringify(ciudadData));
                    localStorage.setItem('ciudadesLastFetch', Date.now().toString());
                    
                    setLoadingciudades(false);
                  },
                  error: (err) => {
                    console.error("Error al parsear CSV:", err);
                    setErrorciudades("Error al procesar los datos");
                    setLoadingciudades(false);
                  }
            });
    
      }
      catch(error){
          console.error("Error al obtener datos:", error);
          setErrorciudades("Error al cargar los datos");
          setLoadingciudades(false);
      }
      finally{
          setLoadingciudades(false);
      }
   
    }

    const cargarMaterias = async() =>{
      try{
        setLoadingMaterias(true);
        const data = await obtenerListas.getAllMaterias();
        const materiasLista = data.map(materiaData => Materia.fromJson(materiaData));

        console.log("obtneido materias",data);
        
        // Filtrar solo las materias activas
        //const materiasActivas = materiasLista.filter(materia => materia.activo === true);
        const materiasActivas = materiasLista.filter(materia => 
          materia.materiaActiva === true && materia.nombremateria !== ""
        );

        setMaterias(materiasActivas);
        seterrorMaterias(null);
        return materiasActivas;
      }
      catch(error){
        seterrorMaterias(error.message || "Error al cargar la solicitud");
        return null;
      }
      finally{
        setLoadingMaterias(false);
      }
      
    }
    const materiasOptions = useMemo(() => {
        return materias?.map(materia => ({
          value: materia.nombremateria, // o materia.id si tienes un ID
          label: materia.nombremateria
        })) || [];
    }, [materias]);

    //cargar materias de plataforma
    const cargarMateriasPLataforma = async() =>{
      try{
            setLoadingmateriasPlataforma(true);

            const data = await obtenerListas.getMateriasProPlataforma();
            const dataConvertida = Object.values(data);
            
            console.log("universidades cargadas,",data);

            setMateriaPlataformas(dataConvertida);
            seterrorMateriasPlataforma(null);

            return dataConvertida;
        }
        catch(error){
            console.error("Error al obtener datos:", error);
            seterrorMateriasPlataforma("Error al cargar los datos");
        }finally{
           setLoadingmateriasPlataforma(false);
        }
    };
    const materiasPlataformaOptions = useMemo(() => {
        return materiasPlataforma?.map(materia => ({
          value: materia, // o materia.id si tienes un ID
          label: materia
        })) || [];
    }, [materiasPlataforma]);

    //cargar fase de plataforma
    const cargarFasePlataformas = async() =>{
      try{
        setLoadingfasePlataforma(true);

        const data = await obtenerListas.getFasesProPlataforma();
        const dataConvertida = Object.values(data);
            
        console.log("universidades cargadas,",data);

        setfasePlataforma(dataConvertida);
        seterrorfasePlataforma(null);

        return dataConvertida;
        }
        catch(error){
            console.error("Error al obtener datos:", error);
            seterrorfasePlataforma("Error al cargar los datos");
        }finally{
           setLoadingfasePlataforma(false);
        }
    };
    const faseasPlataformaOptions = useMemo(() => {
        return fasePlataforma?.map(fase => ({
          value: fase, // o materia.id si tienes un ID
          label: fase
        })) || [];
    }, [fasePlataforma]);

    //cargar platafoma de plataformas
    const cargarPlataformaPlataformas = async() =>{
      try{
        setLoadingplataformaPlataforma(true);

        const data = await obtenerListas.getPlataformaProPlataforma();
        const dataConvertida = Object.values(data);
            
        setplataformaPlataforma(dataConvertida);
        seterrorplataformaPlataforma(null);

        return dataConvertida;
        }
        catch(error){
            console.error("Error al obtener datos:", error);
            seterrorplataformaPlataforma("Error al cargar los datos");
        }finally{
           setLoadingplataformaPlataforma(false);
        }
    };
    const plataformaPlataformasOptions = useMemo(() => {
        return plataformaPlataforma?.map(fase => ({
          value: fase, // o materia.id si tienes un ID
          label: fase
        })) || [];
    }, [plataformaPlataforma]);

    //carga semestre de plataformas
    const cargarSemestrePlataformas = async() =>{
      try{
        setLoadingsemestrePlataforma(true);

        const data = await obtenerListas.getSemestreProPlataforma();
        const dataConvertida = Object.values(data);
            
        setsemestrePlataforma(dataConvertida);
        seterrorsemestrePlataforma(null);

        return dataConvertida;
        }
        catch(error){
            console.error("Error al obtener datos:", error);
            seterrorsemestrePlataforma("Error al cargar los datos");
        }finally{
           setLoadingsemestrePlataforma(false);
        }
    };
    const semestrePlataformaOptions = useMemo(() => {
        return semestrePlataforma?.map(fase => ({
          value: fase, // o materia.id si tienes un ID
          label: fase
        })) || [];
    }, [semestrePlataforma]);

    //examenes de tutores
    //objeto == modelo
    const cargarExamenesTutores = async() =>{
      try{
        setLoadingexamenesPruebasTutores(true);

        const data = await obtenerListas.getPruebasExamenesTutores();
        const dataConvertida = Object.values(data);
        
        console.log("examenes cargados",dataConvertida);

        setexamenesPruebasTutores(dataConvertida);
        setErrorexamenesPruebasTutores(null);

      }
      catch(error){
        console.error("Error al obtener datos:", error);
        setErrorexamenesPruebasTutores("Error al cargar los examenes de pruebas tutores");
      }
      finally{
        setLoadingexamenesPruebasTutores(false);
      }
    };
    const examenesTutoresOptions = useMemo(() =>{
       return examenesPruebasTutores?.map(examen => ({
          value: examen, // o materia.id si tienes un ID
          label: examen,
        })) || [];
    }, [examenesPruebasTutores]);

    
  
    return{
        //universidades
        universidades,
        universidadesOptions,
        isLoadingUniversidad,
        erroruniversidades,
        cargarUniversidades,

        //carreras
        carreras,
        carrerasOptions,
        isLoadingCarreras,
        errorCarreras,
        cargarCarreras,

        //paises
        paises,
        isLoadingpaises,
        errorpaises,
        cargarPaises,

        //ciudades
        ciudades,
        isLoadingciudades,
        errorciudades,
        cargarCiudades,

        //materias
        materias,
        materiasOptions,
        isLoadingMaterias,
        errorMaterias,
        cargarMaterias,

        //materias pro plataforma
        materiasPlataformaOptions,
        cargarMateriasPLataforma,

        //fases pro plataforma
        faseasPlataformaOptions,
        cargarFasePlataformas,

        //plataformas de platafoemas
        cargarPlataformaPlataformas,
        plataformaPlataformasOptions,

        //cargar semestres
        semestrePlataformaOptions,
        cargarSemestrePlataformas,

        //examenes proplataforma
        examenesTutoresOptions,
        cargarExamenesTutores,

    }

}